import { jsPDF } from 'jspdf';
import { toast } from 'react-toastify';

export const downloadProjectPDF = async (project, formatDate, formatCostInINR) => {
  try {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4"
    });

    const primaryColor = [30, 41, 59]; // Dark blue
    const secondaryColor = [79, 70, 229]; // Indigo
    const textColor = [33, 37, 41]; // Dark Gray

    const addHeader = (title) => {
      doc.setFillColor(...primaryColor);
      doc.rect(0, 0, 210, 25, 'F');
      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.setTextColor(255, 255, 255);
      doc.text(title, 105, 16, { align: 'center' });
    };

    const addSectionTitle = (title, y) => {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.setTextColor(...primaryColor);
      doc.text(title, 15, y);
      doc.setDrawColor(...secondaryColor);
      doc.setLineWidth(0.7);
      doc.line(15, y + 2, 60, y + 2);
    };

    const addFooter = () => {
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setDrawColor(220, 220, 220);
        doc.line(15, 280, 195, 280);
        doc.setFontSize(10);
        doc.setTextColor(150, 150, 150);
        doc.text(`Page ${i} of ${pageCount}`, 105, 285, { align: 'center' });
        doc.text("CONFIDENTIAL", 195, 285, { align: 'right' });
      }
    };

    // --------- PAGE 1 ---------
    addHeader(`PROJECT DETAILS: ${project.project_name?.toUpperCase() || ''}`);

    let yPosition = 35;

    addSectionTitle("Project Overview", yPosition);
    yPosition += 10;

    const fields = [
      { label: 'Sector', value: project.sector || 'N/A' },
      { label: 'Cost', value: formatCostInINR(project.cost) },
      { label: 'Status', value: project.status || 'N/A' },
      { label: 'Location', value: `${project.city || ''}, ${project.state || ''}, ${project.country || ''}`.replace(/^, /, '').replace(/, , /g, ', ') || 'N/A' },
      { label: 'Start Date', value: formatDate(project.startDate) },
      { label: 'End Date', value: formatDate(project.endDate) },
      { label: 'Contractor', value: project.contractor || 'N/A' },
      { label: 'Registrar Office', value: project?.district?.registrarOffice ?? 'N/A' },
      { label: 'Circle Rate', value: project?.district?.circleRate ?? 'N/A' },
      { label: 'District Magistrate', value: project?.district?.districtMagistrate ?? 'N/A' },
      { label: 'Population', value: project?.district?.population?.toLocaleString() ?? 'N/A' },
    ];

    const leftColX = 15;
    const rightColX = 110;
    const labelWidth = 35;

    doc.setFontSize(12);
    doc.setTextColor(...textColor);

    fields.forEach((field, index) => {
      const colX = index % 2 === 0 ? leftColX : rightColX;
      if (index % 2 === 0 && index !== 0) yPosition += 10;

      doc.setFont("helvetica", "bold");
      doc.text(`${field.label}:`, colX, yPosition);

      doc.setFont("helvetica", "normal");
      doc.text(field.value, colX + labelWidth, yPosition);

      if (index % 2 !== 0) yPosition += 5;
    });

    // --------- PAGE 2 (Description) ---------
    if (project.description) {
      doc.addPage();
      addHeader("PROJECT DESCRIPTION");

      let descY = 35;

      addSectionTitle("Description", descY);
      descY += 10;

      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(...textColor);

      const descriptionLines = doc.splitTextToSize(project.description, 180);
      doc.text(descriptionLines, 15, descY);
    }

    // --------- PAGE 3 (Timeline) ---------
    doc.addPage();
    addHeader("PROJECT TIMELINE");

    let timelineY = 35;

    addSectionTitle("Timeline", timelineY);
    timelineY += 15;

    doc.setFontSize(13);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(...primaryColor);

    doc.text("Start Date:", 15, timelineY);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(...textColor);
    doc.text(formatDate(project.startDate), 50, timelineY);

    timelineY += 10;

    doc.setFont("helvetica", "bold");
    doc.setTextColor(...primaryColor);
    doc.text("End Date:", 15, timelineY);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(...textColor);
    doc.text(formatDate(project.endDate), 50, timelineY);

    // --------- Footer on all pages ---------
    addFooter();

    // Save PDF
    doc.save(`${project.project_name.replace(/\s+/g, '_')}_Detailed_Report.pdf`);

  } catch (error) {
    console.error("Error generating PDF:", error);
    toast.error("Failed to generate PDF. Please try again.");
  }
};

// import { jsPDF } from 'jspdf';
// import { toast } from 'react-toastify';

// export const downloadProjectPDF = async (project, formatDate, formatCostInINR) => {
//     try {
//         // Initialize PDF
//         const doc = new jsPDF({
//             orientation: "portrait",
//             unit: "mm",
//             format: "a4"
//         });

//         // Set default font
//         doc.setFont("helvetica");

//         // Add header with colored background
//         doc.setFillColor(30, 41, 59);
//         doc.rect(0, 0, 210, 30, 'F');
        
//         // Add title
//         doc.setFontSize(20);
//         doc.setTextColor(255, 255, 255);
//         doc.text(`PROJECT DETAILS: ${project.project_name.toUpperCase()}`, 105, 20, { align: 'center' });

//         // Reset text color for body
//         doc.setTextColor(0, 0, 0);

//         // Add project overview section
//         doc.setFontSize(16);
//         doc.setTextColor(30, 41, 59);
//         doc.text("Project Overview", 15, 45);
        
//         // Add decorative line
//         doc.setDrawColor(79, 70, 229);
//         doc.setLineWidth(0.5);
//         doc.line(15, 47, 60, 47);

//         // Create two-column layout
//         let yPosition = 60;
//         const leftCol = 15;
//         const rightCol = 110;
        
//         const fields = [
//             { label: 'Sector', value: project.sector || 'N/A' },
//             { label: 'Cost', value: formatCostInINR(project.cost) },
//             { label: 'Status', value: project.status || 'N/A' },
//             { label: 'Location', value: `${project.city || ''}, ${project.state || ''}, ${project.country || ''}`.replace(/^, /, '').replace(/, , /g, ', ') || 'N/A' },
//             { label: 'Start Date', value: formatDate(project.startDate) },
//             { label: 'End Date', value: formatDate(project.endDate) },
//             { label: 'Contractor', value: project.contractor || 'N/A' },
//             { label: 'Registrar Office', value: project?.district?.registrarOffice ?? 'N/A' },
//             { label: 'Circle Rate', value: project?.district?.circleRate ?? "N/A" },
//             { label: 'District Magistrate', value: project?.district?.districtMagistrate ?? "N/A" },
//             { label: 'Population', value: project?.district?.population?.toLocaleString() ?? "N/A" },
//         ];

//         // Add details in two columns
//         doc.setFontSize(12);
//         fields.forEach((field, index) => {
//             const col = index % 2 === 0 ? leftCol : rightCol;
//             if (index % 2 === 0 && index !== 0) yPosition += 10;
            
//             // Add label
//             doc.setFont("helvetica", "bold");
//             doc.text(`${field.label}:`, col, yPosition);
            
//             // Add value
//             doc.setFont("helvetica", "normal");
//             doc.text(field.value, col + 35, yPosition);
            
//             if (index % 2 !== 0) yPosition += 10;
//         });

//         // Add project description section
//         if (project.description) {
//             doc.addPage();
//             doc.setFontSize(16);
//             doc.setTextColor(30, 41, 59);
//             doc.text("Project Description", 15, 20);
//             doc.line(15, 22, 60, 22);
            
//             doc.setFontSize(11);
//             const descriptionLines = doc.splitTextToSize(project.description, 180);
//             doc.text(descriptionLines, 15, 30);
//         }

//         // Add timeline section
//         doc.addPage();
//         doc.setFontSize(16);
//         doc.setTextColor(30, 41, 59);
//         doc.text("Project Timeline", 15, 20);
//         doc.line(15, 22, 50, 22);
        
//         // Timeline details
//         doc.setFontSize(12);
//         doc.text("Start Date:", 15, 40);
//         doc.text(formatDate(project.startDate), 50, 40);
        
//         doc.text("End Date:", 15, 50);
//         doc.text(formatDate(project.endDate), 50, 50);
        
//         // Footer on all pages
//         const pageCount = doc.internal.getNumberOfPages();
//         for (let i = 1; i <= pageCount; i++) {
//             doc.setPage(i);
            
//             // Footer line
//             doc.setDrawColor(200, 200, 200);
            
//             // Fixed footer line position to ensure it doesn't go out of bounds
//             doc.line(15, 280, 195, 280); // Draw a line at the bottom of the page
            
//             // Page number
//             doc.setFontSize(10);
//             doc.setTextColor(150, 150, 150);
//             doc.text(`Page ${i} of ${pageCount}`, 105, 285, { align: 'center' });
            
//             // Confidential notice
//             doc.text("CONFIDENTIAL", 195, 285, { align: 'right' });
//         }

//         // Save the PDF
//         doc.save(`${project.project_name.replace(/\s+/g, '_')}_Detailed_Report.pdf`);
        
//     } catch (error) {
//         console.error("Error generating PDF:", error);
//         toast.error("Failed to generate PDF. Please try again.");
//     }
// };
